import {
  LottieSettings,
  ArticleModel,
  Domrefs,
  TextboxDataset,
  ArticleModelObserver,
  BackgroundAnimation,
} from "./types";
import * as HELPERS from "./helpers";
import { BASE_URL } from "../../posthtml.config";
import * as VENDORS from "./vendors";
import { LottiePlayer, PlayerEvents } from "@lottiefiles/lottie-player";
import { backgroundAnimations } from "./backgroundAnimations";

export class Observers implements ArticleModelObserver {
  Domrefs: Domrefs;
  lottieLoaded: boolean = false;
  currentLottieAnimation: LottiePlayer | null;
  target = 0;
  otsikkoShouldBeVisible = false;
  playedLottieAnimations = ["a"];
  constructor(Domrefsarg: Domrefs) {
    this.Domrefs = Domrefsarg;
  }

  async onVisibleTextboxChange(textbox: HTMLElement, model: ArticleModel) {
    const jsonNode: HTMLScriptElement | null = textbox.querySelector("script");
    this.Domrefs.OTSIKKO.style.visibility = "hidden";
    if (model.resetSpecialEffect) {
      model.resetSpecialEffect();
      model.specialEffect = "";
      model.resetSpecialEffect = () => null;
    }
    this.Domrefs.SISALTO.style.zIndex = 1;



    if (!jsonNode || !jsonNode.textContent) return;
    let json: TextboxDataset;

    try {
      json = JSON.parse(jsonNode.textContent);
    } catch (e) {
      alert("virhe asetuksissa, JSON ei mennyt läpi " + jsonNode.textContent);
      return;
    }

    const destroyLottie = () => {
      if (this.Domrefs.LOTTIE) {
        try {
        //this.currentLottieAnimation?.destroy();
        } catch {
          console.log("error when destroying")
        }
        this.Domrefs.LOTTIE.innerHTML = "";
        model.resetLottieAnimation();
      }
    };

    if (!this.lottieLoaded) {
      // @ts-ignore
      this.lottieLoaded = await HELPERS.loadLottie();
    }
    const {
      aikajana_teksti,
      tausta,
      lottie_animaatio,
      erikoisefekti,
      erikoisefektin_tyyppi,
    } = json;
    const { piilota_taustasta, taustan_animaatio, tiedosto } = tausta;
    if (!tiedosto) return;
    const name = tiedosto.substr(0, tiedosto.lastIndexOf("."));
    if(model.currentBackgroundAnimation && model.currentBackgroundAnimation) {
      model.currentBackgroundAnimation.destroy(name);
    }
    model.changeBackground(name);



    if (aikajana_teksti) {
      model.changeAikajanaText(aikajana_teksti);
    }

    if (piilota_taustasta) {
      model.changeHiddenSvgElements(name, piilota_taustasta);
    }

    if (taustan_animaatio) {
      model.changeBackgroundAnimation(taustan_animaatio);
    } else {
      model.changeBackgroundAnimation(
        HELPERS.getDefaultBackgroundAnimationSettings()
      );
    }

    if (
      this.Domrefs.LOTTIE &&
      this.Domrefs.LOTTIE.dataset.esilataus === "true"
    ) {
      this.Domrefs.LOTTIE.style.visibility = "visible";
      this.currentLottieAnimation?.play();
    }

    if (lottie_animaatio) {
      const fileRemains =
        lottie_animaatio.tiedostoNimi === model.currentLottieAnimationFileName;
      const fileNotRemain =
        lottie_animaatio.tiedostoNimi !== model.currentLottieAnimationFileName;
      if (!this.Domrefs.LOTTIE) return;
      if (lottie_animaatio.esilataus === "true") {
        this.Domrefs.LOTTIE.style.visibility = "hidden";
      } else {
        this.Domrefs.LOTTIE.style.visibility = "visible";
      }
      if (fileRemains) {
        // SAMA LOTTIETIEDOSTO PYSYY, ÄLÄ TUHOA
      }

      if (fileNotRemain) {
        destroyLottie();

        model.changeLottieAnimation(lottie_animaatio);
      }
    } else {
      destroyLottie();
    }

    if (erikoisefekti) {
      model.changeSpecialEffect(erikoisefekti, erikoisefektin_tyyppi);
    }
  }

  onAikajanaChange(text: string): void {
    if (!this.Domrefs.AIKAJANA) return;
    if (text === "tyhja") {
      this.Domrefs.AIKAJANA.style.visibility = "hidden";
    } else {
      this.Domrefs.AIKAJANA.style.visibility = "visible";
    }
    this.Domrefs.AIKAJANA.innerText = text;
  }

  onHowMuchReadChange(value: number): void {}

  onProgressOfVisibleTextbox(value: number, model: ArticleModel): void {
    if (model.specialEffect && model.specialEffectType === "skrollattava") {
      this.onSpecialEffectChange(model, undefined);
    }
    if (
      model.currentBackgroundAnimationSettings &&
      model.currentBackgroundAnimationSettings.tyyppi === "skrollattava"
    ) {
      model.changeBackgroundAnimation(
        model.currentBackgroundAnimationSettings,
        value,
        "progressOfVisibleTextbox"
      );
    }
  }

  onHiddenElementsChange(
    backgroundName: string,
    oldHiddenSvgElements: string[],
    newHiddenSvgElements: string[]
  ): void {
    if (!this.Domrefs.TAUSTAKANGAS) return;
    const container: HTMLObjectElement | null =
      this.Domrefs.TAUSTAKANGAS?.querySelector("#tausta-" + backgroundName);
    const getSvgElement = (): SVGElement | null | undefined =>
      container?.contentDocument?.querySelector("svg");
    newHiddenSvgElements.forEach((element) => {
      if (!element) return;
      if (!getSvgElement()) {
        if (container) {
          container.addEventListener("load", () => {
            hide(element);
          });
        }
      } else {
        hide(element);
      }
    });

    oldHiddenSvgElements.forEach((element) => {
      const elementIsNotAmongNewHiddenElements =
        newHiddenSvgElements.indexOf(element) == -1;
      if (elementIsNotAmongNewHiddenElements) {
        show(element);
      }
    });

    function show(element: string) {
      if (!element) return;
      const node: HTMLElement | null | undefined =
        getSvgElement()?.querySelector("#" + element);
      if (node) node.style.opacity = "1";
    }

    function hide(element: string) {
      const node: SVGElement | null | undefined =
        getSvgElement()?.querySelector("#" + element);
      if (node) node.style.opacity = "0";
    }
  }

  onBackgroundChange(newBackground: string, oldBackground: any): void {
    if (!this.Domrefs.TAUSTAKANGAS) return;
    const newBackgroundElement: HTMLElement | null =
      this.Domrefs.TAUSTAKANGAS.querySelector("#tausta-" + newBackground);
    const oldBackgroundElement: HTMLElement | null =
      this.Domrefs.TAUSTAKANGAS.querySelector("#tausta-" + oldBackground);

    if (newBackgroundElement) {
      newBackgroundElement.style.opacity = "1";
    }

    if (oldBackgroundElement) {
      oldBackgroundElement.style.opacity = "0";
    }
  }

  onBackgroundAnimationChange(
    bgElementName: string,
    settings: BackgroundAnimation,
    oldSettings: BackgroundAnimation,
    model: ArticleModel,
    scrollProgress?: number,

  ): void {
    if (!this.Domrefs.TAUSTAKANGAS) return;

    const container: HTMLObjectElement | null =
      this.Domrefs.TAUSTAKANGAS?.querySelector("#tausta-" + bgElementName);
    const getSvgElement = (): SVGElement | null | undefined =>
      container?.contentDocument?.querySelector("svg");

    const img = container?.querySelector("img");
    createAnimation(container);

    async function createAnimation(container: HTMLElement) {
      const animatedElement = container;

      const startSettings = settings.start;
      const endSettings = settings.end;
      const isScrollType = settings.tyyppi === "skrollattava";

      const transitionDelay = settings.delay ? settings.delay : 0;

      const hasScrollData =
        typeof scrollProgress === "number" &&
        settings.tyyppi === "skrollattava";
      const factor = hasScrollData ? scrollProgress : 1;
      const transitionDuration = hasScrollData ? 0 : 1;
      if (
        animatedElement &&
        endSettings.scale &&
        endSettings.translate &&
        endSettings.translate.x &&
        endSettings.translate.y
      ) {
        let x = Number(endSettings.translate.x),
          y = Number(endSettings.translate.y),
          scale = Number(endSettings.scale);

        if (isScrollType) {
          if (!hasScrollData) return;

          const scrollBasedPositions = HELPERS.getPositionAlongTheLine(
            startSettings.translate.x,
            startSettings.translate.y,
            endSettings.translate.x,
            endSettings.translate.y,
            scrollProgress / 100
          );

          x = scrollBasedPositions.x;
          y = scrollBasedPositions.y;

          scale = HELPERS.getPositionAlongTheLine(
            startSettings.scale,
            startSettings.scale,
            endSettings.scale,
            endSettings.scale,
            scrollProgress / 100
          ).x;
          animatedElement.style.transition = `transform ${transitionDuration}s easeinout`;
          //animatedElement.style.transitionDelay = transitionDelay + "s";
          const transform = `scale(${scale}) translate(${x}px, ${y}px)`;
          animatedElement.style.transform = transform;
        } else {
          console.log({ backgroundAnimations, id: settings.id, f: backgroundAnimations[settings.id] });
          console.log(typeof backgroundAnimations[settings.id]  === "function")
          const animation = typeof backgroundAnimations[settings.id]  === "function" ? await backgroundAnimations[settings.id](model) : undefined
          if(!animation){
            console.log("Cannot find animation for " + settings.id)
          }  else {
            animation.run();
             model.currentBackgroundAnimation = animation;
          }

          /*             animatedElement.style.transition = `transform`;
            animatedElement.style.transitionTimingFunction = "easeinout";
            animatedElement.style.transitionDuration =`${transitionDuration}s`
            animatedElement.style.transitionDelay = transitionDelay + "s";
            const transform = `scale(${scale}) translate(${x}px, ${y}px)`;
            animatedElement.style.transform = transform;    */
        }
      }
    }
  }

  async onLottieAnimationChange(settings: LottieSettings) {
    if (settings.id) {
      if (this.playedLottieAnimations.indexOf(settings.id) > -1) {
        console.log("already played");
        return;
      }
    }

    const createAnimation = () => {
      const animationContainer: HTMLElement | null =
        HELPERS.getDOMRefs().LOTTIE;
      if (!animationContainer) return;
      if (settings.esilataus) {
        animationContainer.style.visibility = "hidden";
        animationContainer.dataset.esilataus = "true";
      } else {
        animationContainer.style.visibility = "visible";
        animationContainer.dataset.esilataus = "false";
      }
      animationContainer.innerHTML = "";
      console.log({
        shouldLoop: settings.looppaa === "true",
        loop: settings.looppaa,
      });
      if (!settings.tiedostoNimi) return;
      const template = `  <lottie-player  
			src="${BASE_URL + "/" + settings.tiedostoNimi}"
			 ${settings.looppaa === "true" ? "loop" : ""}
       ${settings.autoplay === "false" ? "" : " autoplay"}>
	    </lottie-player>`;
      animationContainer.innerHTML = template;
      this.currentLottieAnimation = animationContainer.querySelector(
        "lottie-player"
      ) as LottiePlayer;
    };

    if (!this.lottieLoaded) {
      this.lottieLoaded = await HELPERS.loadLottie();
      createAnimation();
    } else {
      createAnimation();
    }
    if (settings.id) {
      this.currentLottieAnimation?.addEventListener("complete", () => {
        this.playedLottieAnimations.push(settings.id);
      });
    }
  }

  onSpecialEffectChange(
    model: ArticleModel,
    storeSpecialEffectResetFunction
  ): void {
    if (!this.Domrefs.LOTTIE) return;
    let createLehvaSiirtyma = lehvaSiirtyma.bind(this);
    let currentLottie = this.currentLottieAnimation;
    switch (model.specialEffect) {
      case "opacity-feidaus":
        this.Domrefs.LOTTIE.style.opacity = "1";
        this.Domrefs.LOTTIE.style.transition = "3s opacity";
        this.Domrefs.LOTTIE.style.transitionDelay = "1s";
        this.Domrefs.LOTTIE.style.opacity = "0";
        if (storeSpecialEffectResetFunction) {
          storeSpecialEffectResetFunction(() => {
            if (!this.Domrefs.LOTTIE) return;
            this.Domrefs.LOTTIE.style.opacity = "1";
            this.Domrefs.LOTTIE.style.transition = "";
            this.Domrefs.LOTTIE.style.transitionDelay = "";
          });
        }
        break;
      case "otsikko":
        if (this.otsikkoShouldBeVisible) {
          this.Domrefs.OTSIKKO.style.visibility = "visible";
          this.Domrefs.OTSIKKO.style.display = "block";
          if (!this.nappiClicked) {
            this.Domrefs.OTSIKKO.style.zIndex = 9999;
            this.Domrefs.SISALTO.style.zIndex = -1;
          }
          model.changeLottieAnimation({
            tiedostoNimi: "suruvaippa.json",
            looppaa: "true",
          });
          return;
        }
        createLehvaSiirtyma("10_otsikko", true);
        if (this.currentLottieAnimation) {
          this.currentLottieAnimation.addEventListener("complete", () => {
            model.changeLottieAnimation({
              tiedostoNimi: "suruvaippa.json",
              looppaa: "true",
            });
          });
        }
        break;
      case "maan alla":
        createLehvaSiirtyma("1800", false);
        let paused = false;
        const stop = (e) => {
          if (e.detail.frame > 80 && !paused) {
            this.currentLottieAnimation?.pause();
            paused = true;
            this.currentLottieAnimation?.removeEventListener("frame", stop);
          }
        };

        const onComplete = () => {
          model.changeLottieAnimation({
            tiedostoNimi: "sienirihmasto_2.json",
            looppaa: "false",
            autoplay: "false",
          });
          if (!this.currentLottieAnimation) return;
          this.currentLottieAnimation.addEventListener("ready", () => {
            this.currentLottieAnimation?.play();
            this.currentLottieAnimation?.addEventListener("frame", stop);
          });
        };

        if (this.currentLottieAnimation) {
          this.currentLottieAnimation.addEventListener("complete", onComplete);
        }
        if (storeSpecialEffectResetFunction) {
          storeSpecialEffectResetFunction(() => {
            if (!this.currentLottieAnimation) return;
            this.currentLottieAnimation.removeEventListener(
              "complete",
              onComplete
            );
            this.currentLottieAnimation.removeEventListener("frame", stop);
          });
        }
        break;
      case "rihmasto2":
        currentLottie = this.currentLottieAnimation;
        const stop2 = (e) => {
          if (e.detail.frame > 180) {
            if (!currentLottie) return;
            currentLottie.pause();
            currentLottie.removeEventListener("frame", stop2);
            playSecondPart();
          }
        };

        function playSecondPart() {
          if (!currentLottie) return false;
          currentLottie.seek(80);
          currentLottie.play();
          currentLottie.addEventListener("frame", stop2);
        }
        playSecondPart();
        currentLottie?.addEventListener("ready", playSecondPart);
        if (storeSpecialEffectResetFunction) {
          storeSpecialEffectResetFunction(() => {
            if (!this.currentLottieAnimation) return;
            this.currentLottieAnimation.removeEventListener("frame", stop2);
            this.currentLottieAnimation.removeEventListener(
              "ready",
              playSecondPart
            );
          });
        }
        break;
      case "rihmasto3":
        currentLottie = this.currentLottieAnimation;

        const completed = () => {
          console.log("complete run");
          if (!currentLottie) return;
          currentLottie.removeEventListener("complete", completed);
          playThirdPart();
        };

        function playThirdPart() {
          if (!currentLottie) return false;
          currentLottie.seek(180);
          currentLottie.play();
          currentLottie.addEventListener("complete", completed);
        }
        playThirdPart();
        currentLottie?.addEventListener("ready", playThirdPart);
        if (storeSpecialEffectResetFunction) {
          storeSpecialEffectResetFunction(() => {
            if (!currentLottie) return;
            currentLottie.removeEventListener("complete", completed);
            currentLottie.removeEventListener("ready", playThirdPart);
          });
        }
        break;
      case "rihmasto4":
        currentLottie = this.currentLottieAnimation;

        function playFourthPart() {
          if (!currentLottie) return false;
          currentLottie.seek(180);
          currentLottie.play();
          currentLottie.pause();
        }
        playFourthPart();
        currentLottie?.addEventListener("ready", playFourthPart);
        if (storeSpecialEffectResetFunction) {
          storeSpecialEffectResetFunction(() => {
            if (!currentLottie) return;
            currentLottie.removeEventListener("ready", playFourthPart);
          });
        }
        break;
      case "paahenkilo":
        if (this.playedLottieAnimations.indexOf("paahenkilo") > -1) {
          this.onBackgroundChange("11_1022vuotta", model.currentBackground);
          model.currentBackground = "11_1022vuotta";
        }

        createLehvaSiirtyma("11_1022vuotta", false, true);
        break;
      case "traktori":
        console.log(model.currentBackground + "-extralayer");
        const extralayer = document.getElementById(
          "tausta-" + model.currentBackground + "-extralayer"
        );
        if (extralayer) {
          extralayer.style.opacity = "1";
          extralayer.style.zIndex = "2";
        }
        if (storeSpecialEffectResetFunction) {
          storeSpecialEffectResetFunction(() => {
            if (extralayer) {
              extralayer.style.opacity = "0";
              extralayer.style.zIndex = "0";
            }
          });
        }

        break;
      case "kartta":
        const extralayer_kartta = document.getElementById(
          "tausta-" + model.currentBackground + "-extralayer-1"
        );
        const extralayer_karjala = document.getElementById(
          "tausta-" + model.currentBackground + "-extralayer-0"
        );
        if (extralayer_kartta) {
          extralayer_kartta.style.opacity = "1";
          extralayer_kartta.style.zIndex = "2";
        }
        if (extralayer_karjala) {
          extralayer_karjala.style.opacity = "1";
          extralayer_karjala.style.zIndex = "2";
        }
        if (storeSpecialEffectResetFunction) {
          storeSpecialEffectResetFunction(() => {
            if (extralayer_kartta) {
              extralayer_kartta.style.opacity = "0";
              extralayer_kartta.style.zIndex = "0";
            }

            if (extralayer_karjala) {
              extralayer_karjala.style.opacity = "0";
              extralayer_karjala.style.zIndex = "0";
            }
          });
        }
        break;
      case "mustikat":
        const extralayer_mustikat1 = document.getElementById(
          "tausta-" + model.currentBackground + "-extralayer"
        );
        if (extralayer_mustikat1) {
          extralayer_mustikat1.style.opacity = "1";
          extralayer_mustikat1.style.zIndex = "2";
        }
        if (storeSpecialEffectResetFunction) {
          storeSpecialEffectResetFunction(() => {
            if (extralayer_mustikat1) {
              extralayer_mustikat1.style.opacity = "0";
              extralayer_mustikat1.style.zIndex = "0";
            }
          });
        }

        break;
      
        case "talvisota":
        console.log(model.currentBackground + "-extralayer");
        const extralayer_sota = document.getElementById(
          "tausta-" + model.currentBackground + "-extralayer"
        );
        if (extralayer_sota) {
          extralayer_sota.style.opacity = "1";
          extralayer_sota.style.zIndex = "2";
        }
        if (storeSpecialEffectResetFunction) {
          storeSpecialEffectResetFunction(() => {
            if (extralayer_sota) {
              extralayer_sota.style.opacity = "0";
              extralayer_sota.style.zIndex = "0";
            }
          });
        }

        break;
      case "metsapalo":
        const showMetsaPalo = () => {
          const metsapaloEtuala: HTMLElement | null = document.getElementById(
            "tausta-metsapalo_etuala"
          );
          if (metsapaloEtuala) {
            metsapaloEtuala.style.opacity = "1";
            metsapaloEtuala.style.transition = "opacity 0s";
            metsapaloEtuala.style.zIndex = "3";
          }
        };
        this.currentLottieAnimation?.addEventListener("load", showMetsaPalo);

        if (storeSpecialEffectResetFunction) {
          const metsapaloEtuala: HTMLElement | null = document.getElementById(
            "tausta-metsapalo_etuala"
          );
          storeSpecialEffectResetFunction(() => {
            this.currentLottieAnimation?.removeEventListener(
              "load",
              showMetsaPalo
            );
            if (metsapaloEtuala) {
              metsapaloEtuala.style.opacity = "0";
              metsapaloEtuala.style.zIndex = "0";
            }
          });
        }
      default:
      // code block
    }

    const buttonClick = () => {
      this.Domrefs.LOPPUARTIKKELI.style.display = "block";
      this.Domrefs.NAPPI.style.display = "none";
      this.nappiClicked = true;
      const element = document.getElementById(
        "ensimmainen-loppuartikkelista"
      );
      const ylaOffset = window.innerHeight / 1.5;
      const elementPosition =
        element?.getBoundingClientRect().top || 0;

        if(true) {
          const offsetPosition =
          elementPosition +
          window.pageYOffset -
          ylaOffset;
          console.log(offsetPosition)
          window.scrollTo({
            top: offsetPosition,
          });
        } else {
          const offsetPosition =
          elementPosition +
          this.Domrefs.APPCONTAINER.scrollTop -
          ylaOffset;
      this.Domrefs.APPCONTAINER.scrollTo({
        top: offsetPosition,
      });}
    }
    
    function lehvaSiirtyma(
      id: string,
      isOtsikko: boolean,
      isPaahenkilo: boolean
    ) {
      let lehvaHasPlayed = false;



      const changeBackground = (e) => {

        if (e.detail.frame > 30 && !lehvaHasPlayed) {
          if (!isOtsikko && !isPaahenkilo) lehvaHasPlayed = true;
          model.changeBackground(id);
          if (this.Domrefs.OTSIKKO && isOtsikko) {
            this.Domrefs.OTSIKKO.style.visibility = "visible";
            this.Domrefs.OTSIKKO.style.display = "block";
            if (this.Domrefs.NAPPI) {
              this.Domrefs.NAPPI.removeEventListener("click", buttonClick);
              this.Domrefs.NAPPI.addEventListener("click", buttonClick);
            }
            if (e.detail.frame > 50) {
              this.Domrefs.OTSIKKO.style.zIndex = 9999;
              this.Domrefs.SISALTO.style.zIndex = -1;
              lehvaHasPlayed = true;
              this.otsikkoShouldBeVisible = true;
            }
          }
          if (isPaahenkilo && e.detail.frame > 55) {
            document.getElementById(
              "ensimmainen-loppuartikkelista"
            ).style.transition = "opacity 1.5s";
            document.getElementById(
              "ensimmainen-loppuartikkelista"
            ).style.opacity = 1;
          }
        }
      };

      if (isOtsikko) {
        this.Domrefs.LOPPUARTIKKELI.style.display = "none";
      }
      this.currentLottieAnimation?.removeEventListener(
        "frame",
        changeBackground
      );
      this.currentLottieAnimation?.addEventListener("frame", changeBackground);
      //this.Domrefs.LOTTIE.style.transform = "scale(1)"; // this hack is needed to avoid cropping in siirtyma_metsan_verhot.json
      if (storeSpecialEffectResetFunction) {
        storeSpecialEffectResetFunction(() => {
          this.currentLottieAnimation?.removeEventListener(
            "frame",
            changeBackground
          );
          if (this.Domrefs.OTSIKKO && isOtsikko) {
            this.Domrefs.OTSIKKO.style.visibility = "hidden";
            this.Domrefs.OTSIKKO.style.zIndex = 1;
            this.Domrefs.OTSIKKO.style.display = "none";
            this.Domrefs.SISALTO.style.zIndex = 1;
          }

        //  this.Domrefs.LOTTIE.style.transform = "scale(1)";
        });
      }
    }
  }
}
